module.exports = __webpack_public_path__ + "static/media/33.a0f1589b.jpg";